{
  "name": "homeleite",
  "version": "1.0.107-hml.101",
  "license": "MIT",
  "scripts": {
    "admin:ng": "nx --project=admin",
    "admin:nx": "nx --project=admin",
    "admin:start": "nx serve --project=admin  --disable-host-check",
    "admin:test": "nx test --project=admin",
    "admin:build": "nx build --project=admin",
    "admin:build-prod": "nx build --project=admin --configuration production --aot",
    "admin:deploy": "firebase deploy --only hosting:administrator-parleite",
    "homeleite:start": "nx serve --project=homeleite",
    "homeleite:dev": "nx serve --project=homeleite --configuration=development",
    "homeleite:build": "nx build --project=homeleite --configuration production --aot",
    "homeleite:build-staging": "nx build --project=homeleite --configuration staging --aot",
    "homeleite:deploy": "firebase deploy --only hosting:homeleite",
    "homeleite:deploy-staging": "firebase deploy --only hosting:staging-homeleite",
    "ng": "nx",
    "nx": "nx",
    "start": "nx serve homeleite",
    "build": "nx run-many -t build",
    "test": "nx run-many -t test",
    "lint": "nx run-many -t lint",
    "e2e": "nx run-many -t e2e",
    "affected:apps": "nx show projects --affected",
    "affected:libs": "nx show projects --affected",
    "affected:build": "nx affected -t build",
    "affected:e2e": "nx affected -t e2e",
    "affected:test": "nx affected -t test",
    "affected:lint": "nx affected -t lint",
    "affected:dep-graph": "nx graph --affected",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "nx migrate latest",
    "dep-graph": "nx graph",
    "help": "nx help"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/architect": "^0.2202.2",
    "@angular/cdk": "22.2.2",
    "@angular/common": "22.2.2",
    "@angular/compiler": "22.2.2",
    "@angular/core": "22.2.2",
    "@angular/forms": "22.2.2",
    "@angular/material": "22.2.2",
    "@angular/material-moment-adapter": "22.2.2",
    "@angular/platform-browser": "22.2.2",
    "@angular/router": "22.2.2",
    "@angular/service-worker": "22.2.2",
    "@ecodev/fab-speed-dial": "^22.0.0",
    "@fontsource/roboto": "^5.2.10",
    "@ngneat/until-destroy": "^10.0.0",
    "@ngx-loading-bar/core": "^7.0.1",
    "chart.js": "^4.5.1",
    "date-fns": "^4.4.0",
    "jwt-decode": "^4.0.0",
    "material-icons": "^1.13.14",
    "moment": "^2.31.0",
    "ng2-charts": "^11.0.0",
    "ngx-indexed-db": "22.0.0",
    "ngx-infinite-scroll": "^22.0.0",
    "pdfmake": "^0.3.11",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^14.0.3",
    "zone.js": "~0.16.3"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.8.0",
    "@analogjs/vitest-angular": "^2.8.0",
    "@angular-devkit/core": "22.2.2",
    "@angular-devkit/schematics": "22.2.2",
    "@angular/build": "^22.2.2",
    "@angular/cli": "22.2.2",
    "@angular/compiler-cli": "22.2.2",
    "@angular/language-service": "22.2.2",
    "@eslint/js": "^10.0.1",
    "@nx/angular": "23.3.0",
    "@nx/eslint": "23.3.0",
    "@nx/eslint-plugin": "23.3.0",
    "@nx/js": "23.3.0",
    "@nx/playwright": "^23.3.0",
    "@nx/vite": "^23.3.0",
    "@nx/vitest": "^23.3.0",
    "@nx/web": "23.3.0",
    "@nx/workspace": "23.3.0",
    "@playwright/test": "^1.64.0",
    "@types/node": "^26.6.5",
    "@types/pdfmake": "^0.3.3",
    "@vitest/coverage-v8": "^5.0.3",
    "angular-eslint": "^22.6.0",
    "eslint": "^10.12.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-playwright": "^2.12.1",
    "jsdom": "^30.1.2",
    "ng-packagr": "22.2.4",
    "nx": "23.3.0",
    "prettier": "^3.9.10",
    "ts-node": "^10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.71.1",
    "vite": "^8.3.4",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^5.0.3",
    "webpack-bundle-analyzer": "^5.4.0"
  },
  "overrides": {
    "undici": "^8.11.2"
  }
}
